import WindowTracker from './window-tracker.class';

const windowTracker = new WindowTracker();
let initialized = false;

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          windowTracker,
        };
      },
      created() {
        if (!initialized) {
          windowTracker.init();
        }
      },
    });
  },
};
